import { DEFAULT_SETTINGS } from './../constants';
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { take, map, tap } from 'rxjs/operators';
import { SettingsService } from '../settings/settings.service';
import { Preferences } from '@capacitor/preferences';
import { Settings } from '../settings/settings.type';


@Injectable({
  providedIn: 'root'
})
export class TabsService {

  shiftSub: Subscription;
  userType: string;
  title: string;
  recordsShowSettingsDisabled: boolean;
  graphsShowSettingsDisabled: boolean;

  constructor(private settingService: SettingsService) { }

  public _tabsUpdated = new Subject<Settings>();

  get tabsUpdated() {
    return this._tabsUpdated.asObservable();
  }

  reloadTabs() {
    // patient app navigation
    return this.settingService.fetchSettingFromServer().pipe(
      take(1),
      map((settings) => {

        if (Object.keys(settings).length > 0) {
          const settingList = Object.keys(settings).map(key =>  settings[key]);
          settingList.sort((a, b) => (new Date(a.date).getTime() > new Date(b.date).getTime()) ? 1 : -1);
          const mostRecentSetting = settingList[settingList.length - 1].data;
          SettingsService.settings = mostRecentSetting;
          this.settingService.setObject('settings', mostRecentSetting);
          return mostRecentSetting;
        } else {
          this.settingService.setObject('settings', DEFAULT_SETTINGS);
          //send default settings to server
          this.settingService.sendSettingsToServer();
          return DEFAULT_SETTINGS;
        }
        // if no settings, set default settings
        //this._settingData.next(SettingsService.settings);
      }),
      tap<Settings>(settings => {
        if (settings && settings.showSettings) {
          this.recordsShowSettingsDisabled = !settings.showSettings.recordingsTab;
          this.graphsShowSettingsDisabled = !settings.showSettings.graphsTab;
        }
        // check if headless mode
        if (settings && settings.showSettings.isHeadless) {
          this.recordsShowSettingsDisabled = true;
          this.graphsShowSettingsDisabled = true;
        }
        this._tabsUpdated.next(settings);
      })
    );
  }

    async getUserType() {
      return await Preferences.get({key:'userType'}).then(
        type => type.value);
    }

    getDisabledTabs() {
      return {
        records: this.recordsShowSettingsDisabled,
        graphs: this.graphsShowSettingsDisabled
      };
    }


}
